import React from 'react';
import styled from 'styled-components';
import { ItemType, GraphMode } from '../../constants';
import { NodeModel } from '../../types';
import { updateGlobal } from '../../utils';
import { DEFAULT_NODE_SIZE, DEFAULT_NOTE_SIZE } from '../../shapes';
import { EditorContextProps, withEditorContext } from '../../hooks';

export interface FlowChartDndTileProps extends EditorContextProps {
  style?: React.CSSProperties;
  className?: string;
  children: React.ReactNode;
  /** Is this a node or edge? */
  type?: ItemType;
  /** Any data should be copied over to the canvas node after drag */
  model: Partial<NodeModel>;
  /** Is the tile disabled */
  isDisabled?: boolean;
}

const FlowChartDndTileWrapper = styled.div<FlowChartDndTileProps>`
  /** prevents text highlighting getting in the way of the drag function */
  user-select: none;
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'grab')};
`;

class FlowChartDndTileCmp extends React.Component<FlowChartDndTileProps> {
  static defaultProps = {
    type: ItemType.Node,
    isDisabled: false,
  };

  handleMouseDown = () => {
    const { graph, type, model = {}, isDisabled = false } = this.props;

    if (!graph) return;
    if (isDisabled) return;
    if (type !== ItemType.Node) return;

    updateGlobal(graph, {
      component: {
        itemPanel: {
          model: {
            size: model.isNote ? DEFAULT_NOTE_SIZE : DEFAULT_NODE_SIZE,
            /**
             * `center: 'topLeft'` fixes "jump" on node drop
             * See: https://iterable.atlassian.net/browse/WF-469
             */
            center: 'topLeft',
            ...model,
          },
        },
      },
    });

    graph?.setMode(GraphMode.AddNode);
  };

  render() {
    const { children } = this.props;

    return (
      <FlowChartDndTileWrapper
        type={ItemType.Node}
        {...this.props}
        onMouseDown={this.handleMouseDown}
      >
        {children}
      </FlowChartDndTileWrapper>
    );
  }
}

export const FlowChartDndTile = withEditorContext<FlowChartDndTileProps>(FlowChartDndTileCmp);

export default FlowChartDndTile;
